import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyProductCard4.vue?vue&type=template&id=630c231e"
import script from "./MoleculeEditionBillingAcademyProductCard4.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyProductCard4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports